/**
 * Imports both the core and the component styles as well as the default theme
 *
 */

import './dnb-ui-core.scss'
import './themes/theme-ui/ui-theme-components.scss'
import './themes/theme-ui/ui-theme-basis.scss'
